import {
    DEFAULT_FROZEN_COLUMNS,
    DEFAULT_COLUMN_WIDTHS,
    DEFAULT_COLUMN_ORDER,
    DEFAULT_VISIBLE_COLUMNS,
} from 'src/app/pages/quote/page/articles/items/items-view/services/items-table.columns';
import { CatalogSortKey } from 'src/app/pages/quote/page/articles/catalogs/catalog-view/components/catalog-toolbar/catalog-sort/catalog-sort.component';

// **************************************************************************
// ARTICLES TABLE FILTER STATE
// **************************************************************************

export interface ExpandCommand {
    type: 'expand' | 'collapse';
    requestId: number;
}

export interface ArticlesFilterState {
    frozenColumns: Record<string, boolean>;
    columnWidths: Record<string, number>;
    columnOrder: string[];
    visibleColumns: string[];
    globalBrandFilter: string[];
    groupBrandFilters: Record<number, string[]>;
    itemBrandFilters: Record<number, string[]>;
    expandCommand: ExpandCommand | null;
}

export const initialArticlesFilterState: ArticlesFilterState = {
    frozenColumns: DEFAULT_FROZEN_COLUMNS,
    columnWidths: DEFAULT_COLUMN_WIDTHS,
    columnOrder: DEFAULT_COLUMN_ORDER,
    visibleColumns: DEFAULT_VISIBLE_COLUMNS,
    globalBrandFilter: [],
    groupBrandFilters: {},
    itemBrandFilters: {},
    expandCommand: null,
};

// **************************************************************************
// PRODUCT CATALOG FILTER STATE
// **************************************************************************

export interface ProductCatalogFilterState {
    searchText: string;
    selectedCatalogIds: number[];
    selectedCategories: string[];
    selectedProductGroupFilterNames: string[];
    sortBy: CatalogSortKey;
}

export const initialProductCatalogFilterState: ProductCatalogFilterState = {
    searchText: "",
    selectedCatalogIds: [],
    selectedCategories: [],
    selectedProductGroupFilterNames: [],
    sortBy: 'DEFAULT',
};
